import { useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Icon from "../../../components/Icon/Icon";
import EmptyData from "./../../EmptyData/EmptyData";
import { convertDate, convertRoleToPath } from "../../../utils";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  areYouSureMessage,
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { setMetaAction } from "../../../redux/actions/metaActions/metaActions";
import { readAllNotificationUserService } from "../../../services/userServices";
import { convertNotificationTypeToColor } from "./../../../utils/enum/index";

const UserNotification = () => {
  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.meta?.notifications);
  const auth = useSelector((state) => state.auth);

  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((prevState) => !prevState);

  // Read All Notification
  const handleReadAllNotification = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await readAllNotificationUserService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        dispatch(setMetaAction());
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <Dropdown isOpen={open} toggle={toggle} className="user-dropdown">
      <DropdownToggle tag="a" className="dropdown-toggle nk-quick-nav-icon">
        <div
          className={`icon-status text-secondary icon-status-${
            !isEmpty(notifications) ? "info" : "na"
          }`}
        >
          <img src="/assets/images/icons/notification.png" alt="notification" />
        </div>
      </DropdownToggle>
      <DropdownMenu left className="dropdown-menu-xl dropdown-menu-s1">
        <div className="dropdown-head">
          <span className="sub-title nk-dropdown-title">اعلان ها</span>
          {!isEmpty(notifications) && (
            <span
              type="button"
              className="text-primary"
              onClick={() =>
                areYouSureMessage(
                  handleReadAllNotification,
                  `آیا از ویرایش اطلاعیه ها به خوانده شده مطمئنید؟`
                )
              }
            >
              خواندن همه
            </span>
          )}
        </div>
        <div className="dropdown-body">
          <div className="nk-notification">
            {isEmpty(notifications) ? (
              <div className="m-2">
                <EmptyData />
              </div>
            ) : (
              <>
                {notifications.map((item) => (
                  <div className="nk-notification-item" key={item._id}>
                    <div className="nk-notification-icon">
                      <Icon
                        name="curve-down-left"
                        className={`icon-circle bg-${convertNotificationTypeToColor(
                          item.type
                        )}-dim`}
                      />
                    </div>
                    <div className="nk-notification-content">
                      <div className="nk-notification-text">{item?.title}</div>
                      <div className="nk-notification-time">
                        {convertDate(item?.createdAt, "YYYY-MM-DD HH:mm")}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div className="dropdown-foot center">
          <Link
            onClick={toggle}
            to={`/${convertRoleToPath(auth?.role)}/notifications`}
          >
            نمایش همه
          </Link>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserNotification;
